import { useCallback } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { Input, version2 } from 'ui-components/components/input';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { emptyObject } from 'ui-components/default-props/empty';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import messages from '../messages';
import style from '../style.module.less';

const BarcodeCell = ({ row, handleBarcodeChange }) => {
  const { id, toteBarcode, isDuplicateBarcode } = row?.original || emptyObject;
  const intl = useIntl();

  const onChange = useCallback(
    (e) => {
      const newBarcode = e?.target?.value;
      handleBarcodeChange({ id, newBarcode });
    },
    [handleBarcodeChange, id],
  );

  return (
    <div className={style['input-cell-wrapper']}>
      <Input
        className={style['editable-input']}
        hasError={isDuplicateBarcode}
        inlineMessage={isDuplicateBarcode ? intl.formatMessage(messages.duplicateBarcodeError) : undefined}
        inlineMessageType={isDuplicateBarcode ? INLINE_MESSAGE_TYPES.error : undefined}
        onChange={onChange}
        placeholder={intl.formatMessage(messages.barcodePlaceholder)}
        value={toteBarcode}
        version={version2}
      />
    </div>
  );
};

export const createBarcodeColumnDefinition = () => {
  return createColumnDefinitionBuilder({
    accessor: 'toteBarcode',
    Header: <FormattedMessage {...messages.barcodeColumnHeader} />,
    Cell: BarcodeCell,
    width: 300,
  })();
};
